import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VTextField,{class:_vm.textFieldClass,attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"clearable":""},on:{"input":_vm.input,"keydown":_vm.keydown}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }